import { render, staticRenderFns } from "./CustomDropdown.vue?vue&type=template&id=c0801708&scoped=true"
import script from "./CustomDropdown.vue?vue&type=script&lang=js"
export * from "./CustomDropdown.vue?vue&type=script&lang=js"
import style0 from "./CustomDropdown.vue?vue&type=style&index=0&id=c0801708&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0801708",
  null
  
)

export default component.exports